<!-- 悬浮球 -->
<template>
  <div class="floatBtn" :style="bgStyle" @click="handleClick"></div>
</template>

<script>
import handleRedirect from '../mixins/pureHandleRedirect';

export default {
  props: {
    buttonImage: String
  },
  mixins: [handleRedirect],
  computed: {
    bgStyle() {
      return {
        background: `center / cover url("${this.buttonImage}") no-repeat`
      };
    }
  },
  mounted() {
    this.$emit('reportEvent', {
      event: 'component_expo',
      module_name: this.$t ? this.$t('track.base_comp_float_btn') : '悬浮球'
    });
  },
  methods: {
    handleClick() {
      this.$emit('reportEvent', {
        event: 'component_button_click',
        module_name: this.$t ? this.$t('track.base_comp_float_btn') : '悬浮球'
      });
      this.handleRedirect();
    }
  }
};
</script>

<style lang="less" scoped>
.floatBtn {
  position: fixed;
  right: 0;
  bottom: 423px;
  width: 160px;
  height: 160px;
}
</style>
